
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"opacity":".1","d":"M-2-2h16v16H-2z"}}),_c('path',{attrs:{"d":"M8.204 5.918l3.435-3.442A1.5 1.5 0 009.524.36L6.082 3.796 2.639.36A1.5 1.5 0 00.524 2.476L3.96 5.918.524 9.361a1.5 1.5 0 102.115 2.115L6.082 8.04l3.442 3.435A1.5 1.5 0 0011.64 9.36L8.204 5.918z","fill":"#86909E","fill-rule":"nonzero"}})])])
          )
        }
      }
    